import React, {useState} from 'react';
import DemandCreate from "../../components/crud/DemandCreate";
import Main from "../../components/main/Main";
import DemandList from "../../components/list/DemandList";

function DavaIcraHukukuMutalaa(props) {
    const [refreshList, setRefreshList] = useState(false);
    return (
        <Main>
            <DemandCreate type={3} updateButtonClicked={updateButtonClicked} setUpdateButtonClicked={setUpdateButtonClicked} selectedRow={selectedRow} refreshList={refreshList} setRefreshList={setRefreshList} pageTitle={"M&A-Hisse Devralınması İşlemleri"}/>
            <DemandList refreshList={refreshList} onUpdateButtonClicked={onUpdateButtonClicked} setRefreshList={setRefreshList} />
        </Main>
    );
}

export default DavaIcraHukukuMutalaa;